module.exports = __webpack_public_path__ + "img/5-1.a9b254d6.svg";